"use client";

import { useTranslation } from "@/app/i18n/client";
import type { Breadcrumbs } from "@/libs/server/goApiServer/hotel/hotelServiceInterfaces/getHotelSeoContent";
import { numberToLocaleString } from "@/utils/data/priceFormatter";

import HotelSearchLayoutMainPageComponent from "./HotelSearchComponent/HotelSearchLayoutComponents/HotelSearchLayoutMainPageComponent/HotelSearchLayoutMainPageComponent";

interface HotelSearchBoxForSeoComponentProps {
  searchBoxHeading: Breadcrumbs;
  hotelsTotal: number;
}

const HotelSearchBoxForSeoComponent = ({
  searchBoxHeading,
  hotelsTotal,
}: HotelSearchBoxForSeoComponentProps) => {
  const { t } = useTranslation("home");
  const { countryName, cityName, areaName } = searchBoxHeading;

  const HeadingRender = () => {
    if (areaName) return `${cityName},${countryName} `;
    if (cityName) return t("newSeo.country", { location: countryName });
    return "";
  };

  const generateAutoFill = (): string => {
    if (areaName) return `${areaName}, ${cityName}, ${countryName}`;
    if (cityName) return `${cityName}, ${countryName}`;
    return "";
  };

  return (
    <div>
      <HotelSearchLayoutMainPageComponent
        title={
          <div className="flex flex-col py-[1.063rem] text-center text-white">
            <h1 className="text-xl font-bold md:text-xxl">
              {t("newSeo.searchBox.heading", {
                location: areaName || cityName || countryName,
              })}
            </h1>
            <span className="text-lg font-normal md:text-xl">
              {HeadingRender()}
              {t("newSeo.searchBox.subHeading", {
                hotelTotal: numberToLocaleString(hotelsTotal),
              })}
            </span>
          </div>
        }
        autoFill={generateAutoFill()}
      />
    </div>
  );
};

export default HotelSearchBoxForSeoComponent;
